<template>
  <div>
    <div
        class="google-map"
        ref="googleMap"

    ></div>
  </div>
</template>

<script>
  import {googleMapApi, mapSettings} from "@/config/google-maps";

  export default {
    props: ['infoRoute'],
    data() {
      return {
        google: null,
        map: null,
        info_route: null,
      };
    },
    watch: {
      infoRoute: {
        deep: true,
        handler(val) {
          if (val && val.start.latitude && val.end.latitude) {
            // Small delay to ensure DOM is ready
            this.$nextTick(() => {
              this.initializeMap();
            });
          }
        }
      }
    },
    async mounted() {
      const self = this;
      self.google = googleMapApi;
      self.google = self.google._result;
      // Don't initialize map here - wait for infoRoute to be properly set
      // this.initializeMap();
    },

    methods: {
      set_route(param) {
        const self = this;
        self.$emit("route", param);
      },
      initializeMap() {
        const self = this;
        
        // Validate that we have all required coordinates
        if (!self.infoRoute || 
            !self.infoRoute.start.latitude || 
            !self.infoRoute.start.longitude ||
            !self.infoRoute.end.latitude || 
            !self.infoRoute.end.longitude) {
          console.warn("GoogleMapLoader: Incomplete coordinates, skipping map initialization", self.infoRoute);
          return;
        }

        const mapContainer = this.$refs.googleMap;
        if (!mapContainer) {
          console.warn("GoogleMapLoader: Map container not found");
          return;
        }

        const mapC = self.mapConfig;
        self.map = new self.google.maps.Map(mapContainer, mapC);
        var directionsService = new self.google.maps.DirectionsService();
        var directionsRenderer = new self.google.maps.DirectionsRenderer();
        directionsRenderer.setMap(self.map);

        var start = new self.google.maps.LatLng(self.infoRoute.start.latitude, self.infoRoute.start.longitude);
        var end = new self.google.maps.LatLng(self.infoRoute.end.latitude, self.infoRoute.end.longitude);

        directionsService.route({
          origin: start,
          destination: end,
          travelMode: 'DRIVING',
          drivingOptions: {
            departureTime: new Date(Date.now()),
            trafficModel: 'pessimistic'
          },
        }, function (result, status) {
          if (status === 'OK') {
            directionsRenderer.setDirections(result);
            self.set_route(result);
          }
        });
      }
    },
    computed: {
      mapConfig() {
        const self = this;
        return {
          mapSettings: mapSettings,
          center: self.mapCenter
        };
      }
      ,

      mapCenter() {
        const self = this;
        return new self.google.maps.LatLng(self.infoRoute.start.latitude, self.infoRoute.start.longitude);
      }
    }

  }
</script>

<style scoped>
  .google-map {
    width: 100%;
    min-height: 100%;
  }
</style>
